const nps = {
  nps: {
    npsBreakdown: 'Répartition du NPS',
    npsScore: 'Score NPS',
    npsSpread: 'Propagation du NPS',
    npsDashboard: 'TABLEAU DE BORD DU NPS',
    npsDetails: 'Détails du NPS',
    npsTrend: 'Tendance du NPS',
    verbatims: 'Verbatims',
    timePeriod: 'Périodes : ',
    to: 'à',
    pastMonths: '%{month} derniers mois',
    ratingType: 'Type de notation',
    systemId: 'ID du système',
    systemName: 'Nom du système',
    rating: 'Notation',
    comments: 'Commentaires',
    all: 'Tous',
    promoter: 'Partisan',
    promoters: 'Partisans',
    detractor: 'Détracteur',
    detractors: 'Détracteurs',
    passive: 'Passif',
    noData: 'Aucune donnée disponible',
    npsDashboardTooltip: {
      whatIs: 'Qu’est-ce que le taux de recommandation net ?',
      npsDefine:
        'Le taux de recommandation net est un indice, variant de -100 à 100, qui mesure la propension des clients à recommander une société à d’autres personnes. Il est utilisé comme approximation pour mesurer la satisfaction générale des clients.',
      questionIs:
        'La question est posée sous la forme suivante : «\xa0Sur une échelle de 0 à 10, quelle est la probabilité que vous recommanderiez notre organisation à un ami ou un collègue ?\xa0» Selon le chiffre que le client choisit, il est classé dans l’une des catégories suivantes : «\xa0Détracteurs\xa0», «\xa0Passifs\xa0» et «\xa0Partisans.\xa0» Répartition du score : 0 - 6 : Détracteurs, 7 - 8 : Passifs, 9 - 10 : Partisans',
      determined:
        'Le taux de recommandation net (NPS) est déterminé en soustrayant le pourcentage de clients détracteurs du pourcentage de partisans. Se trouve alors généré un score entre -100 et 100 appelé le taux de recommandation net.',
      how: 'Comment Enphase détermine le NPS pour vous ?',
      shownBelow:
        'Enphase incite les propriétaires à fournir des notations dans l’application Enlighten Mobile comme montré dans les écrans ci-dessous. Selon les notations fournies, le NPS est déterminé tel que décrit ci-dessus.'
    },
    timePeriodTooltip:
      'La période par défaut couvre les 13 derniers mois. Si le Score NPS n’est pas disponible pour les 13 derniers mois, alors le score est inclus depuis le premier mois disponible.',
    verbatimsTooltip:
      'Tous les commentaires affichés ici viennent de propriétaires de système qui ont donné leur consentement pour les partager avec les installateurs.',
    jan: "Jan'",
    feb: "Fév'",
    mar: "Mar'",
    apr: "Avr'",
    may: "Mai'",
    jun: "Juin'",
    jul: "Juil'",
    aug: "Août'",
    sep: "Sep'",
    oct: "Oct'",
    nov: "Nov'",
    dec: "Déc'",
    ofTotal: 'sur un total',
    ratings: 'Notations',
    numberOfReviews: 'Nombre de revues',
    date: 'Date',
    between0And10: 'Veuillez taper une valeur entre 0 et 10',
    lessThan50: 'Le nombre de caractères doit être inférieur à 50',
    npsBasedOnScore: `NPS de %{score} selon %{count} notations`
  }
};

export default nps;
